import {IStore} from "modules/store";
import {createSelector} from "@reduxjs/toolkit";
import {RequestState} from "modules/enums";
import {find} from "lodash";

export const getLeaderboardsState = ({leaderboards}: IStore) => leaderboards;

export const getLeaderboardsLoadingState = createSelector(
	getLeaderboardsState,
	({loadingState}) => loadingState
);
export const getSelectedLeaderboard = createSelector(
	getLeaderboardsState,
	({selectedLeaderboard}) => selectedLeaderboard
);
export const getCurrentLeaderboard = createSelector(
	getLeaderboardsState,
	({leaderboards}) => leaderboards
);
export const getFetchedLeaderboardPages = createSelector(
	getLeaderboardsState,
	({fetchedPages}) => fetchedPages
);

export const getLeaderboardUserByUserId = createSelector(
	[getCurrentLeaderboard],
	(ladder) => (userId: number) => {
		return find([...ladder.ranks, ladder.user], {
			userId,
		});
	}
);

export const getProfileByUserId = createSelector(
	[getLeaderboardsState],
	(store) => (userId: number) => {
		return store.profiles[userId];
	}
);

export const isProfileRequested = createSelector(
	[getLeaderboardsState],
	(store) => store.profileRequestState === RequestState.Requested
);
